// Youtuber Form JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.tab-switch-btn');
  const formContent = document.querySelector('.create-youtuber');
  const mobilePreview = document.querySelector('.preview-youtuber-live-stream-mb');
  const desktopPreview = document.querySelector('.preview-youtuber-live-stream');
  let currentMode = window.innerWidth < 768 ? 'mobile' : 'desktop';
  
  function initializeTabSwitching() {
    // Clear all event listeners first
    tabButtons.forEach(button => {
      button.replaceWith(button.cloneNode(true));
    });
    
    // Re-select buttons after cloning
    const newTabButtons = document.querySelectorAll('.tab-switch-btn');
    
    // Reset all displays first
    if (formContent) {
      formContent.style.display = 'block';
    }
    if (mobilePreview) {
      mobilePreview.style.display = 'none';
    }
    if (desktopPreview) {
      desktopPreview.style.display = 'block';
    }
    // Hide final preview
    const finalPreview = document.querySelector('.preview-youtuber');
    if (finalPreview) {
      finalPreview.classList.add('d-none');
    }
    document.body.classList.remove('mobile-preview-active');
    
    // Reset tab buttons
    newTabButtons.forEach(btn => {
      btn.classList.remove('active');
      if (btn.getAttribute('data-tab') === 'form') {
        btn.classList.add('active');
      }
    });
    
    // Only run tab switching on mobile
    if (window.innerWidth < 768) {
      // Hide mobile preview initially
      if (mobilePreview) {
        mobilePreview.style.display = 'none';
      }
      
      newTabButtons.forEach(button => {
        button.addEventListener('click', function() {
          const tab = this.getAttribute('data-tab');
          
          // Remove active class from all buttons
          newTabButtons.forEach(btn => btn.classList.remove('active'));
          // Add active class to clicked button
          this.classList.add('active');
          
          if (tab === 'form') {
            // Show form content
            if (formContent) {
              formContent.style.display = 'block';
            }
            if (mobilePreview) {
              mobilePreview.style.display = 'none';
            }
            // Hide final preview
            const finalPreview = document.querySelector('.preview-youtuber');
            if (finalPreview) {
              finalPreview.classList.add('d-none');
            }
            document.body.classList.remove('mobile-preview-active');
          } else if (tab === 'preview') {
            // Show live preview (preview-youtuber-live-stream-mb) on mobile
            if (formContent) {
              formContent.style.display = 'none';
            }
            if (mobilePreview) {
              mobilePreview.style.display = 'block';
            }
            // Hide the final preview section
            const finalPreview = document.querySelector('.preview-youtuber');
            if (finalPreview) {
              finalPreview.classList.add('d-none');
            }
            document.body.classList.add('mobile-preview-active');
            
            // Update mobile live preview with current form values
            if (typeof updateMobilePreview === 'function') {
              updateMobilePreview();
            }
          }
        });
      });
    }
  }
  
  // Initialize on page load
  initializeTabSwitching();
  
  // Re-initialize on window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const newMode = window.innerWidth < 768 ? 'mobile' : 'desktop';
      if (newMode !== currentMode) {
        currentMode = newMode;
        initializeTabSwitching();
      }
    }, 100);
  });
});
